module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/6_5f531d6c437dc997dcfd44ec90e32585.png";